import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import Header from "../components/header"
import Layout from "../components/layout"
import SEO from "../components/seo"
import DesignTokens from "../components/designTokens"
import ContactForm from "../components/contactForm"
import { Container, IsMobile, IsDesktop } from "../components/utils"
import ContactDetails from "../components/contactDetails"
import Footer from "../components/footer"

const Contact = ({ data: { page } }) => {
  return (
  <Layout>
    <SEO title={page.title} lang="it" />
    <Header image={page.heroImage.url}>
      <h1>{page.title}</h1>
      <h2>{page.subtitle}</h2>
    </Header>
    <IsDesktop>
        <Wrapper>
          <CustomContainer>
            <ContactForm />
            <ContactDetails title={page.subtitle} contact={page.contactMode} people={page.people} />
          </CustomContainer>
        </Wrapper>
    </IsDesktop>
    <IsMobile>
        <MobileCustomContainer>
          <ContactDetails title={page.subtitle} contact={page.contactMode} people={page.people} />
          <ContactForm />
        </MobileCustomContainer>
    </IsMobile>
    <Footer />
  </Layout>
)}


const Wrapper = styled.div`
  padding: ${DesignTokens.spacing[5]};
  @media screen and (min-width: 769px) {
    background: linear-gradient(
      90deg,
      ${DesignTokens.colors.white} 50%,
      ${DesignTokens.colors.primary[500]} 50%
    );
  }
`

const MobileCustomContainer = styled.div`
  & > div {
      padding: ${DesignTokens.spacing[4]};
    &:first-child {
      background: ${DesignTokens.colors.primary[500]};
    }
  }
`

const CustomContainer = styled(Container)`
  @media screen and (min-width: 769px) {
    display: flex;
    flex-direction: row;
    & > div {
      &:first-child {
        padding: ${DesignTokens.spacing[8]} ${DesignTokens.spacing[8]}
          ${DesignTokens.spacing[8]} 0;
      }
      &:last-child {
        padding: ${DesignTokens.spacing[8]} 0 ${DesignTokens.spacing[8]} ${DesignTokens.spacing[8]};
      }
      width: 50%;
    }
  }
`

export default Contact

export const query = graphql`
  query ContactQuery {
    page: datoCmsContact {
      title
      subtitle
      contactMode {
        email
        phone
        additionalInfo
      }
      heroImage {
        url
        alt
      }
      people {
        id
        name
        email
        department
      }
    }
  }
`

